<template>
  <div class="data-section" v-if="!isHiddenLabelRow">
    <div class="data-row">
      <div v-for="entity in entities" :key="entity.id" class="entity-data-group" :class="{ 'entity-average': entity.isAverage }">
        <MatrixCell v-for="wave in entity.waves"
                    :key="wave.id"
                    :mode="item.mode"
                    :item="boardGetData(item.id, entity.id, wave.label, item)"
                    :highlighted="wave.isHighlighted"
                    @mouseenter="boardSetHover(entity.id + '-' + wave.id, item.id)"
                    @mouseleave="boardClearHover()"
                    :class="{
                      'is-hovered-cell': hoveredCol === entity.id + '-' + wave.id && hoveredRow === item.id,
                      'is-hovered-col':  hoveredCol === entity.id + '-' + wave.id,
                      'is-hovered-row':  hoveredRow === item.id
                    }" />
      </div>
    </div>

    <template v-if="item.isOpen && item.children">
      <MatrixDataSection v-for="child in item.children.filter(c => !c.hidden)"
                         :key="child.id"
                         :item="child" />
    </template>
  </div>
</template>

<script>
import MatrixCell from './MatrixCell.vue';

export default {
  name: 'MatrixDataSection',

  components: { MatrixCell },

  inject: [
    'boardGetHoveredRow',
    'boardGetHoveredCol',
    'boardGetEntities',
    'boardGetData',
    'boardSetHover',
    'boardClearHover',
  ],

  props: {
    item: { type: Object, required: true },
  },

  computed: {
    isHiddenLabelRow() {
      return this.item.ShowKpiLabelMode
        && this.item.mode === 'kpi'
        && this.item.children
        && this.item.children.length > 0
        && this.item.children.every(c => c.hidden);
    },
    hoveredRow() { return this.boardGetHoveredRow(); },
    hoveredCol() { return this.boardGetHoveredCol(); },
    entities()   { return this.boardGetEntities(); },
  }
};
</script>

<style lang="scss" scoped>
.data-section {
  display: flex;
  flex-direction: column;
  background-color: white;

  [data-bs-theme="dark"] & {
    background-color: unset;
  }
}

.data-row {
  display: flex;
  gap: 0;
  height: 3rem;
  border-bottom: 1px solid var(--bs-border-color);
}

.entity-data-group {
  display: flex;
  gap: 0;
  border-right: 1px solid var(--bs-border-color);

  &:last-child {
    border-right: none;
  }
}

.entity-average {
  background-color: unset;
  border-right: 2px solid var(--bs-border-color);
}

.is-hovered-row {
  background-color: color-mix(in srgb, var(--bs-border-color) 30%, transparent) !important;
}

.is-hovered-col {
  background-color: color-mix(in srgb, var(--bs-border-color) 20%, transparent) !important;
}

.is-hovered-cell {
  background-color: color-mix(in srgb, var(--target-primary) 15%, transparent) !important;
}
</style>
